import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconBarking } from '../../assets/images/icons/icon_barking_alt.svg';
import { ReactComponent as IconDrip } from '../../assets/images/icons/icon_drip.svg';
import { ReactComponent as IconEating } from '../../assets/images/icons/icon_eating.svg';
import { ReactComponent as IconLicking } from '../../assets/images/icons/icon_licking.svg';
import { ReactComponent as IconMagic } from '../../assets/images/icons/icon_magic.svg';
import { ReactComponent as IconScratching } from '../../assets/images/icons/icon_scratching.svg';
import styles from './HardwareFirstAiBehaviors.module.scss';

// the live s3+ pdp's five behaviors. icons render inline rather than as the pdp's css masks, which
// fetch their svg after paint and can leave the tile blank; each takes its pdp gradient's light end
const AI_BEHAVIORS = [
  {
    Icon: IconEating,
    color: '#e57c23',
    titleKey: 'eating',
    bodyKey: 'stay_tuned_to_shifts_in_appetite_and_keep_track_of_when_theyre_being_fed',
  },
  {
    Icon: IconDrip,
    color: '#6bb4dd',
    titleKey: 'drinking',
    bodyKey: 'know_when_its_time_for_a_water_break_even_before_they_start_panting',
  },
  {
    Icon: IconBarking,
    // the pdp's barking brown sinks into the black band, so this one is lifted
    color: '#c4692a',
    titleKey: 'barking_feature',
    bodyKey: 'get_notified_of_unusually_vocal_or_quiet_days_to_address_any_stressors',
  },
  {
    Icon: IconScratching,
    color: '#e8a735',
    titleKey: 'scratching',
    bodyKey: 'keep_tabs_on_your_dogs_skin_health_to_spot_signs_of_irritation_early_on',
  },
  {
    Icon: IconLicking,
    color: '#d63a57',
    titleKey: 'licking',
    bodyKey: 'track_excessive_licking_to_tackle_sources_of_discomfort',
  },
];

/**
 * The redesign's AI behavior module: the live s3+ pdp's five behaviors as cards on a dark band. A
 * two-up grid leaves the last behavior alone on its row, so a "more coming" card fills it there.
 */
export default function HardwareFirstAiBehaviors() {
  const { t } = useTranslation();
  return (
    <section className={styles.band}>
      <h2 className={styles.title}>{t('ai_behavior_monitoring_title')}</h2>
      <p className={styles.sub}>{t('unleash_a_complete_overview_of_their_habits')}</p>
      <ul className={styles.cards}>
        {AI_BEHAVIORS.map(({ Icon, color, titleKey, bodyKey }) => (
          <li key={titleKey} className={styles.card}>
            <span className={styles.icon} style={{ color }} aria-hidden="true">
              <Icon />
            </span>
            <span className={styles.cardTitle}>{t(titleKey)}</span>
            <span className={styles.cardBody}>{t(bodyKey)}</span>
          </li>
        ))}
        <li className={styles.soon}>
          <span className={styles.soonIcon} aria-hidden="true">
            <IconMagic />
          </span>
          <span className={styles.cardTitle}>{t('pdp_v2_ai_more_title')}</span>
          <span className={styles.cardBody}>{t('pdp_v2_ai_more_body')}</span>
        </li>
      </ul>
    </section>
  );
}
